import { Theme } from "@mui/material";
import { colors, hoverColors } from "../../constants/colors";

const styles = {
  pointerEvent: 'none',
  '& a': {
    backgroundColor: colors.primary,
    boxShadowColor: colors.primary,
    color: colors.white,
    '&:hover': {
      backgroundColor: hoverColors.primary,
      boxShadowColor: hoverColors.primary,
      color: colors.white
    }
  }
};

const endIconButtonStyles: any = (theme?: Theme) => styles;

export default endIconButtonStyles;